"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledUrsaSearchIcon = exports.StyledTextInput = exports.StyledLodestarSearchIcon = exports.StyledButton = exports.SearchIconStyles = void 0;
var _core = require("@emotion/core");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _createFocusRingStyles = require("../../../util/createFocusRingStyles");
var _TextInput = require("../TextInput");
var _formInputTheme = require("./formInputTheme");
const StyledButton = (0, _styled.default)("button")`
    border-style: none;
    background-color: transparent;
    padding: 0;
    height: 30px;
    width: 30px;
    cursor: ${_ref => {
  let {
    isDisabled
  } = _ref;
  return isDisabled ? "default" : "pointer";
}};
    // To force the height to be the children's height.
    display: flex;
    justify-content: center;
    align-items: center;
    // This only applies to the clear button. The search icon takes Clickable's.
    &:focus {
        outline-color: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _createFocusRingStyles.focusRingTheme.outerColor(themeMode);
}};
        border-radius: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _formInputTheme.formInputTheme.searchInputButtonRadius(themeMode);
}};
    }
`;
exports.StyledButton = StyledButton;
const SearchIconStyles = (0, _core.css)`
    // Otherwise the icon is inline-block which gives it a bit more than the specified height.
    display: block;
    cursor: text;
`;
exports.SearchIconStyles = SearchIconStyles;
const StyledLodestarSearchIcon = (0, _styled.default)(_lodestarIcons.SearchIcon)(SearchIconStyles);
exports.StyledLodestarSearchIcon = StyledLodestarSearchIcon;
const StyledUrsaSearchIcon = (0, _styled.default)(_ursaIcons.MagnifyingGlassIcon)(SearchIconStyles);
exports.StyledUrsaSearchIcon = StyledUrsaSearchIcon;
const StyledTextInput = (0, _styled.default)(_TextInput.TextInput)`
    input::-webkit-search-cancel-button {
        display: none; // Hide the native search clear button so we can add our own styled one
    }
`;
exports.StyledTextInput = StyledTextInput;
//# sourceMappingURL=StyledSearchInputComponents.js.map